export default "__VITE_ASSET__CYLD1jXv__"